module.exports = __webpack_public_path__ + "img/Share of Voice_old.66df0620.svg";